"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var profile_1 = require("./profile");
exports.Profile = profile_1.Profile;
var profileSchemas_1 = require("./profileSchemas");
exports.Person = profileSchemas_1.Person;
exports.Organization = profileSchemas_1.Organization;
exports.CreativeWork = profileSchemas_1.CreativeWork;
exports.resolveZoneFileToPerson = profileSchemas_1.resolveZoneFileToPerson;
var profileTokens_1 = require("./profileTokens");
exports.signProfileToken = profileTokens_1.signProfileToken;
exports.wrapProfileToken = profileTokens_1.wrapProfileToken;
exports.verifyProfileToken = profileTokens_1.verifyProfileToken;
exports.extractProfile = profileTokens_1.extractProfile;
var profileProofs_1 = require("./profileProofs");
exports.validateProofs = profileProofs_1.validateProofs;
var serviceUtils_1 = require("./services/serviceUtils");
exports.containsValidProofStatement = serviceUtils_1.containsValidProofStatement;
exports.containsValidAddressProofStatement = serviceUtils_1.containsValidAddressProofStatement;
var profileZoneFiles_1 = require("./profileZoneFiles");
exports.makeProfileZoneFile = profileZoneFiles_1.makeProfileZoneFile;
exports.getTokenFileUrl = profileZoneFiles_1.getTokenFileUrl;
exports.resolveZoneFileToProfile = profileZoneFiles_1.resolveZoneFileToProfile;
var profileLookup_1 = require("./profileLookup");
exports.lookupProfile = profileLookup_1.lookupProfile;
//# sourceMappingURL=index.js.map